import type { ComponentsTheme } from '@/config/app/types'

import { useAppConfig } from './useAppConfig'

/**
 * Composable для получения конфигурации компонентов из темы тенанта
 */
export function useComponentConfig() {
  const appConfig = useAppConfig()
  const componentsConfig = computed<ComponentsTheme | undefined>(() => appConfig.theme.components)

  return {
    componentsConfig,
  }
}
